$(function () {
  if (!customElements.get('factory-brand-authentication')) {
    customElements.define(
      'factory-brand-authentication',
      class FactoryBrandAuthentication extends HTMLElement {
        constructor() {
          super();
          this.$regions = null;
          this.$swiper = null;
          this.activeIndex = 0;
        }

        connectedCallback() {
          this.$regions = this.querySelectorAll('.region');
          if (this.$regions.length == 1) {
            this.$regions[0].style.borderColor = '#ff6600';
          }
          this.initSwiper();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.resizeListener); // 卸载resize事件监听器
        }

        updateRegionState() {
          this.$regions.forEach((region, index) => {
            const $paragraph = region.querySelector('p');

            if (index === this.activeIndex) {
              region.classList.add('border-primary');
              region.classList.remove('border-[#AEB1BC]');
              $paragraph.style.display = 'block';
              gsap.to(region, {
                duration: 0.5,
                borderColor: '#ff6600',
              });
            } else {
              region.classList.remove('border-primary');
              region.classList.add('border-[#AEB1BC]');
              $paragraph.style.display = 'none';
              gsap.to(region, {
                duration: 0.5,
                borderColor: '#AEB1BC',
              });
            }
          });
        }
        initSwiper() {
          // 获取容器宽度并动态调整swiper配置
          const swiperContainer = this.querySelector('.swiper-container'); // 请根据实际的容器选择器调整
          const swiperConfig = this.getSwiperConfig(swiperContainer);

          // 初始化Swiper
          this.$swiper = new Swiper(swiperContainer, swiperConfig);
          const slides = swiperContainer.querySelectorAll('.swiper-slide');
          const secondSlide = slides[1];
          secondSlide.style.filter = 'contrast(0.5)';

          this.$swiper.on('slideChange', function (e) {
            updateFirstSlideTransform(e.activeIndex);
            disableCenterSlideClick(e.activeIndex);
          });

          function updateFirstSlideTransform(activeIndex) {
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            const secondSlide = slides[1]; // 获取第二张幻灯片
            const firstSlide = slides[0];
            if (activeIndex === 1) {
              const translateXValue = secondSlide.offsetLeft + secondSlide.offsetWidth - 100;
              firstSlide.style.transform = `translate3d(${translateXValue}px, 0px, 0) rotateX(0deg) rotateY(0deg) scale(0.9)`;
              firstSlide.style.filter = 'contrast(0.5) ';
              secondSlide.style.filter = 'unset';

              firstSlide.style.zIndex = '-1';
            } else {
              firstSlide.style.transform = 'none';
              firstSlide.style.zIndex = '0';
              firstSlide.style.filter = 'unset';
              secondSlide.style.filter = 'contrast(0.5) ';
            }
          }

          // 禁用当前中间幻灯片的点击
          function disableCenterSlideClick(activeIndex) {
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            const centerSlide = slides[activeIndex]; // 获取当前中间的幻灯片

            // 禁用点击当前中间的幻灯片
            centerSlide.style.pointerEvents = 'none';

            // 启用其他幻灯片的点击
            for (let i = 0; i < slides.length; i++) {
              if (i !== activeIndex) {
                slides[i].style.pointerEvents = 'auto';
              }
            }
          }

          // 点击事件监听
          this.querySelector('.click-area.left-0').addEventListener('click', () => {
            if (this.activeIndex == 0) {
              let index = this.activeIndex;
              this.activeIndex = index + 1;
            } else {
              let index = this.activeIndex;
              this.activeIndex = index - 1;
            }
            this.updateRegionState();
            this.$swiper.slidePrev(); // 切换到上一张
          });

          this.querySelector('.click-area.right-0').addEventListener('click', () => {
            if (this.activeIndex == 0) {
              let index = this.activeIndex;
              this.activeIndex = index + 1;
            } else {
              let index = this.activeIndex;
              this.activeIndex = index - 1;
            }
            this.updateRegionState();
            this.$swiper.slideNext(); // 切换到下一张
          });

          // 禁用第一张幻灯片的点击
          this.querySelector('.swiper-slide:nth-child(1)').addEventListener('click', (event) => {
            event.stopPropagation(); // 阻止事件传播，避免触发点击操作
          });

          gsapLazy(() => {
            this.changeBrandHandle();
          });
        }
        changeBrandHandle() {
          this.$regions = this.querySelectorAll('.region');
          this.updateRegionState();

          this.$regions.forEach((region, index) => {
            region.addEventListener('click', () => {
              if (this.activeIndex !== index) {
                this.activeIndex = index;
                this.updateRegionState();
                this.$swiper.slideTo(this.activeIndex);
              }
            });
          });
        }
        // 获取Swiper配置
        getSwiperConfig(container) {
          const containerWidth = container ? container.offsetWidth : window.innerWidth;

          // 根据容器宽度调整Swiper设置
          if (containerWidth < 900) {
            return {
              effect: 'coverflow',
              grabCursor: true,
              centeredSlides: true,
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 1,
                slideShadows: false,
              },
              slidesPerView: 1.5, // 显示1.5个幻灯片
              spaceBetween: 10, // 增加间距，避免重叠
              loop: false,
              allowTouchMove: false,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            };
          } else {
            return {
              effect: 'coverflow',
              grabCursor: true,
              centeredSlides: true,
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 1,
                slideShadows: false,
              },
              slidesPerView: 2.5, // 显示2.5个幻灯片
              spaceBetween: 30, // 间距30
              loop: false,
              allowTouchMove: false,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            };
          }
        }

        // Resize handler function
        handleResize() {
          const swiperContainer = this.querySelector('.swiper-container');
          const updatedConfig = this.getSwiperConfig(swiperContainer);

          if (this.$swiper) {
            this.$swiper.params = updatedConfig;
            this.$swiper.update();
          } else {
            console.warn('Swiper not initialized yet');
          }
        }
      }
    );
  }
});
